:host {
  display: block;
  padding-bottom: var(--cms-spacing-100);
  height: auto;
}

.rating-count-stars {
  font-size: var(--cms-font-size-087);
  line-height: var(--cms-line-height-100);
  font-family: var(--cms-brandfont2);
  display: inline-block;
  margin-left: var(--cms-spacing-025);
  color: var(--cms-theme-text-color);
  font-weight: var(--cms-heading-base-font-weight);
}

.no-rating-article {
  color: var(--cms-semanticColors-base-strong-background);
  margin-bottom: var(--cms-spacing-075);
  font-size: var(--cms-font-size-075);
}

.ratings-container {
  display: flex;
  align-items: center;
}
